import { Box, ColorOptions, Spacer } from '@jfs/ui-new'
import { TextInputNew } from '../../components/AdminInputs'
import { ButtonNew } from '../../components/AdminButton'
import { useCallback, useEffect, useRef, useState } from 'react'
import { useLazyApiData, useStores } from '../../data/store'

export const UserDataDownloadComp = () => {
  const { exportByJobIdAsync } = useStores((store) => ({
    exportByJobIdAsync: store.exportByJobIdAsync,
  }))

  const abortControllerRef: any = useRef({})

  const getAbortController = useCallback(() => {
    abortControllerRef.current.abortController = new AbortController()
    return abortControllerRef.current
  }, [])

  useEffect(
    () => () => {
      if (abortControllerRef && abortControllerRef.current) {
        abortControllerRef.current.abortRecursive = true
      }
    },
    [],
  )

  const [lazyDownloadUserData, downloadUserDataHandler] = useLazyApiData(exportByJobIdAsync)

  const [mid, setMid] = useState('')

  const onDownload = () => {
    lazyDownloadUserData(
      {
        jobType: 'USER_DETAILS_EXPORT',
        entityDetails: {
          entityId: mid,
        },
      },
      getAbortController,
    )
  }

  return (
    <Box position={'absolute'} right={0} top={0} left={0} bottom={0} pointerEvents="box-none">
      <Box flexDirection={'row'} justify="flex-end" paddingTop={16} paddingRight={16} alignItems={'center'}>
        <TextInputNew
          placeholder="Search By Mid"
          borderColor={'#d1d3e2' as ColorOptions}
          padding={8}
          borderRadius={4}
          value={mid}
          onChangeText={(text) => {
            setMid(text)
          }}
        />
        <Spacer direction="horizontal" size={16} />
        <ButtonNew
          disabled={mid?.length !== 15}
          height={32}
          type="primary"
          isLoading={downloadUserDataHandler.state === 'pending'}
          onPress={onDownload}
          title={'Download'}
        />
      </Box>
    </Box>
  )
}
